module.exports = __webpack_public_path__ + "img/四川天府新区乐美幼儿园.5623a82b.jpg";